'use client'

import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

export interface ModeSegOption {
  value: string
  label: ReactNode
  count?: number | string
}

interface ModeSegProps {
  value?: string
  onChange?: (value: string) => void
  options: ModeSegOption[]
  className?: string
}

export function ModeSeg({ value, onChange, options, className }: ModeSegProps) {
  return (
    <div className={cx('st-mode-seg', className)}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={cx(value === o.value && 'on')}
          data-on={value === o.value}
          onClick={() => onChange?.(o.value)}>
          {o.label}
          {o.count != null && <span className="count">{o.count}</span>}
        </button>
      ))}
    </div>
  )
}
